module.exports = __webpack_public_path__ + "static/media/search.9aade4fe.svg";